module.exports = __webpack_public_path__ + "img/matt-dusk.f90c6302.jpg";